<div #triggerElemRef (click)="onTriggerClick(triggerElemRef)" class="cursor-pointer">
  <ng-content></ng-content>
</div>

<button
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
  class="hidden-button position-absolute t-0 p-0"
  type="button"
></button>

<mat-menu
  #menu="matMenu"
  [xPosition]="menuXPosition"
  [yPosition]="menuYPosition"
  [overlapTrigger]="false"
  class="inline-item-priority"
>
  <ng-template matMenuContent>
    @for (option of priorities; track option) {
      <button mat-menu-item type="button" (click)="selectMenuItem(option)" [class.selected]="option === priority">
        <app-item-priority [priority]="option" [showLabel]="true" [hasTooltip]="false"></app-item-priority>
      </button>
    }
  </ng-template>
</mat-menu>
